module.exports = "/wwwroot/img/hero_block.png?ver=6dbbcbf2";